import { useCallback, useContext } from "react";

import { ToasterContext } from "scenes/Hubly/components/Workspace/Provider";

export function useErrorHandler(setFormError = () => {}) {
  const { fireError } = useContext(ToasterContext);

  const handler = (e) => {
    switch (e?.name) {
      case "param_wrong_value":
        return setFormError(e) || fireError(e.message, e);
      default:
        return fireError(e.message, e);
    }
  };

  return useCallback(handler, [fireError, setFormError]);
}

export default useErrorHandler;
